import { __awaiter, __generator, __read, __spread } from "tslib";
import { collab } from 'prosemirror-collab';
import { createPlugin, pluginKey } from './plugin';
export { CollabProvider } from './provider';
import { sendTransaction } from './events/send-transaction';
export { pluginKey };
var providerBuilder = function (collabEditProviderPromise) { return function (codeToExecute) { return __awaiter(void 0, void 0, void 0, function () {
    var provider, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, collabEditProviderPromise];
            case 1:
                provider = _a.sent();
                if (provider) {
                    codeToExecute(provider);
                }
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                // TODO: ED-9002 Send analytics about failure in collab-edit.send-transaction
                // eslint-disable-next-line no-console
                console.error(err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var collabEditPlugin = function (options) {
    var providerResolver = function () { };
    var collabEditProviderPromise = new Promise(function (_providerResolver) {
        providerResolver = _providerResolver;
    });
    var executeProviderCode = providerBuilder(collabEditProviderPromise);
    return {
        name: 'collabEdit',
        pmPlugins: function () {
            var _a = options || {}, _b = _a.useNativePlugin, useNativePlugin = _b === void 0 ? false : _b, _c = _a.userId, userId = _c === void 0 ? null : _c;
            return __spread((useNativePlugin
                ? [
                    {
                        name: 'pmCollab',
                        plugin: function () { return collab({ clientID: userId }); },
                    },
                ]
                : []), [
                {
                    name: 'collab',
                    plugin: function (_a) {
                        var dispatch = _a.dispatch, providerFactory = _a.providerFactory;
                        providerFactory &&
                            providerFactory.subscribe('collabEditProvider', function (_name, providerPromise) {
                                if (providerPromise) {
                                    providerPromise.then(function (provider) {
                                        return providerResolver(provider);
                                    });
                                }
                            });
                        return createPlugin(dispatch, providerFactory, executeProviderCode, options);
                    },
                },
            ]);
        },
        onEditorViewStateUpdated: function (props) {
            if (options.sendDataOnViewUpdated) {
                executeProviderCode(sendTransaction(props));
            }
        },
    };
};
export default collabEditPlugin;
//# sourceMappingURL=index.js.map